import { Permission } from '@common/index';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: 'imports',
    name: 'importData',
    meta: {
      requiresAuth: true,
      permission: Permission.MENU_ADMINISTRATION
    },
    children: [
      {
        path: '',
        name: 'imports',
        component: () => import('../pages/ImportsPage.vue'),
        children: [
          {
            path: 'entreaty-answers',
            name: 'entreatyAnswers',
            props: true,
            component: () => import('../containers/EntreatyAnswerDetails.vue')
          },
          {
            path: 'prerequisite-update',
            name: 'prerequisiteUpdate',
            props: true,
            component: () => import('../containers/PrerequisiteUpdateDetails.vue')
          }
        ]
      }
    ]
  }
];

export default routes;
